var _a;
export var EVENT_TYPES = {
    KARAOKE_CLUBS: 'Караоке/клубы',
    CAFE_BARS_RESTAURANTS: 'Кафе/бары/рестораны',
    LOUNGE: 'Lounge',
    FITNESS_SPORTS_ACTIVE: 'Фитнес/спорт/активный отдых',
    OTHER: 'Другое'
};
export var EVENT_TYPE_LABELS = (_a = {},
    _a[EVENT_TYPES.KARAOKE_CLUBS] = 'Караоке/клубы',
    _a[EVENT_TYPES.CAFE_BARS_RESTAURANTS] = 'Кафе/бары/рестораны',
    _a[EVENT_TYPES.LOUNGE] = 'Lounge',
    _a[EVENT_TYPES.FITNESS_SPORTS_ACTIVE] = 'Фитнес/спорт/активный отдых',
    _a[EVENT_TYPES.OTHER] = 'Другое',
    _a);
export var EVENT_TYPE_OPTIONS = [
    { value: EVENT_TYPES.KARAOKE_CLUBS, label: EVENT_TYPE_LABELS[EVENT_TYPES.KARAOKE_CLUBS] },
    { value: EVENT_TYPES.CAFE_BARS_RESTAURANTS, label: EVENT_TYPE_LABELS[EVENT_TYPES.CAFE_BARS_RESTAURANTS] },
    { value: EVENT_TYPES.LOUNGE, label: EVENT_TYPE_LABELS[EVENT_TYPES.LOUNGE] },
    { value: EVENT_TYPES.FITNESS_SPORTS_ACTIVE, label: EVENT_TYPE_LABELS[EVENT_TYPES.FITNESS_SPORTS_ACTIVE] },
    { value: EVENT_TYPES.OTHER, label: EVENT_TYPE_LABELS[EVENT_TYPES.OTHER] },
    /** Часто используется в БД как отдельный тип заведения */
    { value: 'Кофейни', label: 'Кофейни' }
];
